export default __webpack_public_path__ + "static/media/ch.5be36d87.mp3";